
/* eslint-disable @typescript-eslint/no-explicit-any */
import Vue from "vue";
import AppEngAssessmentHeader from "./AppEngAssessmentHeader.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import AppEngWrittenAssessment from "./AppEngWrittenAssessment.vue";
import AppEngV3WrittenAssessment from "./AppEngV3WrittenAssessment.vue";
import {
  ViewAssessmentsOptions,
  AppEnglish3McqsAnswers
} from "@/interfaces/candidate/canidate_assessments";
import InterviewLoading from "@/components/candidate/interviews/InterviewLoading.vue";
import {
  AssessmentChat,
  AssessmentChatRoles,
  SubmitAssessmentAnswersApiPayload,
  SubmitAssessmentMcqsAnswersApiPayload,
  UpdateAssessmentQuestionPayload,
  UpdateAssessmentMcqsPayload
} from "@/store/modules/candidates/interfaces";
import {
  APP_ASSESSMENT_SS,
  APP_ENG_ASSESSMENT_CANCELLED,
  APP_ENG_ASSESSMENT_COMPLETED,
  APP_ENG_CURRENT_QUESTION_INDEX,
  ASSESSMENT_AVERAGE_TIME_STATS,
  ASSESSMENT_QUESTIONNAIRES,
  ASSESSMENT_QUESTIONNAIRES_ENGLISH,
  ASSESSMENT_QUESTIONNAIRES_ENGLISH_UPDATE,
  CAMERA_RECORDING_SUPPORTED,
  SCREEN_RECORDING_SUPPORTED,
  SUBMIT_APP_ASSESSMENT_ANSWERS,
  SUBMIT_APP_ASSESSMENT_ANSWER_MEDIA,
  SUBMIT_APP_ASSESSMENT_MEDIA
} from "@/store/modules/candidates/constants";
import { generate_random_key, wait_until } from "@/utils/global";
import {
  isIOS,
  isSafari,
  getMediaRecorderMimeTypes,
  getRecordingMimeTypeAndExt
} from "@/utils/browser.utils";
import moment from "moment";
import {
  GET_USER_DETAILS,
  GET_COMPANY_DETAILS
} from "@/store/modules/auth/constants";
import {
  APP_ASSESSMENTS,
  APP_ASSESSMENT_RESULT,
  SAVE_ASSESSMENT_STATE,
  SITE_DIRECTION,
  UPLOAD_FILE_CHUNK
} from "@/store/modules/common/constants";
import { ROOT_ERROR, ROOT_NOTIFICATION } from "@/store/modules/root/constants";
import AppTimer from "@/components/AppTimer.vue";
import AccessDeniedComponent from "../AccessDeniedComponent.vue";
import AppResourseNotFound from "@/components/candidate/app_assessments/AppResourseNotFound.vue";
import { SiteDirections } from "@/store/modules/common/interfaces";
import ProgressUploader from "@/components/shared/ProgressUploader.vue";
import { AssessmentRecordType } from "@/interfaces/app.interface";
import { get_random_number_between } from "@/utils/global";
import socketService from "@/services/socket.service";
import AssessmentPersistenceService, {
  AssessmentSessionState
} from "@/services/assessment-persistence.service";
import { cancel_my_assessment_attempt } from "@/store/apis/recruiter";
import AppEngReadingQuestionsAssessment from "./AppEngReadingQuestionsAssessment.vue";
import AppEngListeningQuestionsAssessment from "./AppEngListeningQuestionsAssessment.vue";
import AppEngGrammarAssessment from "./AppEngGrammarAssessment.vue";
import AppEngSpeakingAssessment from "./AppEngSpeakingAssessment.vue";
import { AppAssessments } from "@/interfaces/data_objects/app_assessments";

export default Vue.extend({
  name: "AppEngAssessmentRoot",
  components: {
    AppTimer,
    AppEngAssessmentHeader,
    AppEngWrittenAssessment,
    AppEngV3WrittenAssessment,
    InterviewLoading,
    AccessDeniedComponent,
    AppResourseNotFound,
    ProgressUploader,
    AppEngReadingQuestionsAssessment,
    AppEngListeningQuestionsAssessment,
    AppEngGrammarAssessment,
    AppEngSpeakingAssessment
  },
  data() {
    return {
      mcqs_part1_completed: false,
      assessmentTime: 0, //time spend on assessmenty
      partTime: 0, //time spend on part
      questionTime: 0, //time spend on question
      canSelect: true,
      selected_question: "",
      speaking_questions: [] as string[],
      assessment_type: "",
      stage: "",
      answeredMcqsCount: 0,
      disabled_next_question: true as boolean, // To disable next button
      options: [] as AppEnglish3McqsAnswers[],
      error: "" as string, // Global error message
      loading: false as boolean, // Global loading
      media_stopped: false as boolean,
      screen_recroding_start_time: new Date(), // For screen recording start time
      screen_recroding_end_time: new Date(), // For screen recording end time
      camera_recording_start_time: new Date(), // For camera recording start time
      camera_recording_end_time: new Date(), // For camera recording end time
      // For screen recording
      media_stream: null as MediaStream | null, // For screen recording stream
      media_enabled: false as boolean, // To check if screen recording is enabled or not
      screen_recorder: null as MediaRecorder | null, // For screen recording
      screen_recoding_chunks: [] as Blob[], // For screen recording chunks
      // For camera/audio recording
      camera_media_stream: null as MediaStream | null, // For camera stream
      camera_media_recorder: null as MediaRecorder | null, // For camera recording
      camera_media_enabled: false as boolean, // To check if camera is enabled or not
      camera_recorded_blobs: [] as Blob[], // For camera recording chunks
      transcript: "" as string, // User speech transcript
      // eslint-disable-next-line no-undef
      speech_recognition: null as typeof window.webkitSpeechRecognition | null,
      speech_mode: false as boolean, // To check if speech mode is enabled or not
      bot_speaking: true as boolean, // To check if bot is speaking or not
      speaking_history: [] as AssessmentChat[], // To store user speech history
      bot_image: require("@/assets/images/female-bot.png"),
      bot_ans_loading: false as boolean, // To check if bot is answering or not
      submit_ans_loading: false as boolean, // To check if user answer is submitting or no
      // For audio recording
      audio_recorder: null as MediaRecorder | null, // For audio recording
      audio_recorder_chunks: [] as Blob[], // For audio recording chunks
      user_ans_recorder_chunks: [] as Blob[], // For user individual answer recording chunks
      individual_ans_blob: null as Blob | null, // For individual answer blob
      // For Uploading camera/media recording files
      media_uploading: false, // To check if media uploading is in progress or not
      media_uploading_title: "", // Media uploading title
      media_uploading_progress: 0, // Media uploading progress
      ttsAudio: null as HTMLAudioElement | null, // Audio Object
      // When true, user is intentionally leaving this screen (e.g. Go Back),
      // so we should not try to re-request screen sharing or show permission errors.
      isNavigatingAway: false,
      screen_recording_upload_chuk_size: 6 * 1024 * 1024,
      camera_recording_upload_chuk_size: 6 * 1024 * 1024,
      recording: false,
      startTime: 0,
      elapsedTime: "0:0",
      totalPausedTime: 0,
      paused: false,
      pauseStartTime: 0,
      audio_media_stream: null as MediaStream | null, // For camera stream,
      english_assessment_time: 0,
      english_assessment_timer: 0,
      dialog: true,
      is_reload: false,
      disabled_mcqs1_question: true,
      global_progress: 0,
      is_completing_assessment: false, // Flag to prevent reshare dialog during intentional completion
      timers: {} as Record<string, ReturnType<typeof setInterval>>, // Store multiple timer IDs
      answered_question_ids: [] as number[], // Track answered question ids for global progress
      global_time_over: false, // Flag when global english_v4 timer ends
      // Persistence-related state
      autoSaveInterval: null as ReturnType<typeof setInterval> | null,
      lastBackendSaveAt: 0 as number,
      isOffline: false,
      connectionCheckIntervalId: null as ReturnType<typeof setInterval> | null,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      pendingAnswers: [] as any[],
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      childStates: {} as Record<string, any>,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      readingRestoredState: null as any,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      listeningRestoredState: null as any,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      grammarRestoredState: null as any,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      writtenRestoredState: null as any,
      isRestoringSession: false,
      // Timer restoration
      initialRemainingTime: 0, // Set when restoring from saved state
      timerKeyVersion: 0 // Increment to force timer re-render on restore
    };
  },
  computed: {
    ViewAssessmentsOptions() {
      return ViewAssessmentsOptions;
    },
    AssessmentChatRoles() {
      return AssessmentChatRoles;
    },
    ...mapGetters("candidate", {
      app_eng_assessment: ASSESSMENT_QUESTIONNAIRES_ENGLISH,
      current_question_index: APP_ENG_CURRENT_QUESTION_INDEX,
      assessment_cancelled: APP_ENG_ASSESSMENT_CANCELLED,
      assessment_completed: APP_ENG_ASSESSMENT_COMPLETED,
      assessment_ss: APP_ASSESSMENT_SS,
      get_camera_recording_supported: CAMERA_RECORDING_SUPPORTED,
      get_screen_recording_supported: SCREEN_RECORDING_SUPPORTED,
      get_store_data: ASSESSMENT_QUESTIONNAIRES_ENGLISH_UPDATE
    }),
    ...mapGetters("auth", {
      get_user: GET_USER_DETAILS,
      get_company_details: GET_COMPANY_DETAILS
    }),
    ...mapGetters("common", {
      app_assessments: APP_ASSESSMENTS,
      get_site_direction: SITE_DIRECTION
    }),
    SiteDirections() {
      return SiteDirections;
    },
    // Total number of questions across sections for english_v4
    global_total_questions(): number {
      if (
        this.app_eng_assessment.assessment_type !== "english_v4" &&
        this.app_eng_assessment.assessment_type !== "english_v5" &&
        this.app_eng_assessment.assessment_type !== "english_genx_easy_v1" &&
        this.app_eng_assessment.assessment_type !== "english_genx_medium_v1" &&
        this.app_eng_assessment.assessment_type !== "english_technician_v1" &&
        this.app_eng_assessment.assessment_type !==
          "english_lead_technician_v1" &&
        this.app_eng_assessment.assessment_type !==
          "english_assistant_engineer_v1"
      )
        return 0;
      const stored = Number(localStorage.getItem("totalQuestions")) || 0;
      if (stored > 0) return stored;
      // Fallback: derive total from the assessment payload so progress always works.
      return this.getGlobalQuestionIds().length;
    },
    global_answered_count(): number {
      return this.app_eng_assessment.assessment_type === "english_v4" ||
        this.app_eng_assessment.assessment_type === "english_v5" ||
        this.app_eng_assessment.assessment_type === "english_genx_easy_v1" ||
        this.app_eng_assessment.assessment_type === "english_genx_medium_v1" ||
        this.app_eng_assessment.assessment_type === "english_technician_v1" ||
        this.app_eng_assessment.assessment_type ===
          "english_lead_technician_v1" ||
        this.app_eng_assessment.assessment_type ===
          "english_assistant_engineer_v1"
        ? this.answered_question_ids.length
        : 0;
    },
    // Initial remaining time for the timer (calculated once, not reactive to elapsed time)
    // The AppTimer component handles its own countdown internally
    remaining_assessment_time(): number {
      // Use the stored initial remaining time, not a reactive calculation
      return this.initialRemainingTime > 0
        ? this.initialRemainingTime
        : this.english_assessment_time;
    },
    // Key to force timer re-render only when session is restored
    timerKey(): string {
      return `timer-${this.timerKeyVersion}`;
    }
  },
  created() {
    // Random number between 8-15
    const screen_random_number = get_random_number_between(8, 15);
    const camera_random_number = get_random_number_between(8, 15);
    this.screen_recording_upload_chuk_size = screen_random_number * 1024 * 1024;
    this.camera_recording_upload_chuk_size = camera_random_number * 1024 * 1024;
    // Add the event listener when the component is created
    // document.addEventListener("visibilitychange", this.handleVisibilityChange);
  },
  mounted() {
    // Auto-save state every 30s (localStorage + backend for resume)
    this.autoSaveInterval = setInterval(() => {
      this.persistCurrentState();
    }, 30 * 1000);

    // Online/offline detection for connection loss handling
    this.isOffline = !navigator.onLine;
    window.addEventListener("online", this.handleOnline);
    window.addEventListener("offline", this.handleOffline);
    this.connectionCheckIntervalId = setInterval(() => {
      if (this.assessment_completed) return;
      const offline = !navigator.onLine;
      if (offline !== this.isOffline) {
        this.isOffline = offline;
        if (offline) {
          this.set_root_error(
            this.$t("assessments.internet-disconnected").toString()
          );
          this.persistCurrentState();
        }
      }
    }, 2000);
    document.addEventListener("visibilitychange", this.handleVisibilityChange);

    this.init_process(); // To start the Process
    this.check_stage();
    console.log(this.app_eng_assessment);
    // Read TOTAL time from the correct key (not elapsed time)
    let new_ass_time =
      Number(localStorage.getItem("englishAssessmentTotalTime")) || 0;
    this.english_assessment_time = new_ass_time;

    this.startTimer("english_assessment_timer");
    this.increment_question_index(0);

    // Preload previously answered questions for english_v4/v5/genx variants
    if (
      this.app_eng_assessment.assessment_type === "english_v4" ||
      this.app_eng_assessment.assessment_type === "english_v5" ||
      this.app_eng_assessment.assessment_type === "english_genx_easy_v1" ||
      this.app_eng_assessment.assessment_type === "english_genx_medium_v1" ||
      this.app_eng_assessment.assessment_type === "english_technician_v1" ||
      this.app_eng_assessment.assessment_type ===
        "english_lead_technician_v1" ||
      this.app_eng_assessment.assessment_type ===
        "english_assistant_engineer_v1"
    ) {
      this.load_existing_answers();
      this.global_progress =
        (this.global_answered_count / this.global_total_questions) * 100;
    }
  },
  watch: {
    answered_question_ids: {
      handler() {
        // Skip progress update during final submission to prevent overwriting the 100% value
        if (this.is_completing_assessment) return;
        if (this.global_total_questions === 0) return 0;
        const progress =
          (this.global_answered_count / this.global_total_questions) * 100;
        this.global_progress = Math.min(progress, 100);
      },
      deep: true,
      immediate: true
    },
    "app_eng_assessment.filter"(newFilter: string) {
      // #region agent log
      fetch(
        "http://127.0.0.1:7243/ingest/13206365-9101-46c2-a8d8-ea23c925c398",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Debug-Session-Id": "d2ab8d"
          },
          body: JSON.stringify({
            sessionId: "d2ab8d",
            runId: "pre-fix",
            hypothesisId: "H1",
            location: "AppEngAssessmentRoot.vue:filterWatch",
            message: "Filter changed in root",
            data: {
              filter: newFilter,
              assessment_type: this.assessment_type,
              completed: this.assessment_completed
            },
            timestamp: Date.now()
          })
        }
      ).catch(() => {
        // Log not critical
      });
      // #endregion agent log
    },
    // When user logs out during the English assessment (auth store user cleared),
    // immediately stop all media and redirect straight to the login screen
    // without asking for any new camera/microphone/screen permissions.
    get_user(newVal: any) {
      if (!newVal) {
        try {
          this.stopAllMediaStreams();
        } catch (e) {
          // ignore
        }
        this.$router.push("/auth/login");
      }
    }
  },

  methods: {
    generate_random_key,
    ...mapMutations("candidate", {
      set_app_eng_assessments: ASSESSMENT_QUESTIONNAIRES_ENGLISH,
      update_app_eng_assessment_questions:
        ASSESSMENT_QUESTIONNAIRES_ENGLISH_UPDATE,
      increment_question_index: APP_ENG_CURRENT_QUESTION_INDEX,
      set_screen_recording_supported: SCREEN_RECORDING_SUPPORTED,
      set_camera_recording_supported: CAMERA_RECORDING_SUPPORTED
    }),
    ...mapMutations({
      set_root_error: ROOT_ERROR,
      set_root_notification: ROOT_NOTIFICATION
    }),
    ...mapActions("candidate", {
      fetch_assessment_questionnaries: ASSESSMENT_QUESTIONNAIRES,
      submit_assessment_answers: SUBMIT_APP_ASSESSMENT_ANSWERS,
      submit_assessment_media: SUBMIT_APP_ASSESSMENT_MEDIA,
      submit_assessment_ans_media: SUBMIT_APP_ASSESSMENT_ANSWER_MEDIA,
      set_assessment_average_time: ASSESSMENT_AVERAGE_TIME_STATS
    }),
    ...mapActions("common", {
      save_assessment_state: SAVE_ASSESSMENT_STATE,
      upload_file_chunk: UPLOAD_FILE_CHUNK
    }),
    handleNotFoundGoBack() {
      // Same behavior as goToDashboard, but triggered from the shared
      // AppResourseNotFound component when the user clicks "Go Back".
      this.isNavigatingAway = true;
      try {
        this.stopAllMediaStreams();
      } catch (e) {
        // ignore
      }
      const assessmentId = this.app_eng_assessment?.id;
      if (assessmentId != null) {
        cancel_my_assessment_attempt(assessmentId).catch(() => {
          // Non-blocking: still navigate so user sees dashboard
        });
      }
    },
    // Build a stable list of question ids across sections (english_v4/v5/genx)
    getGlobalQuestionIds(): number[] {
      const eng = this.app_eng_assessment as any;
      const ids = new Set<number>();
      const pushIds = (arr: any) => {
        if (!Array.isArray(arr)) return;
        arr.forEach((q: any) => {
          const id = Number(q?.id);
          if (Number.isFinite(id) && id > 0) ids.add(id);
        });
      };
      pushIds(eng?.reading_questions);
      pushIds(eng?.listening_questions);
      pushIds(eng?.mcqs);
      pushIds(eng?.written);
      pushIds(eng?.speaking);
      return Array.from(ids);
    },

    // Load existing answers for english_v4/v5/genx to set initial progress
    async load_existing_answers() {
      try {
        if (
          this.app_eng_assessment.assessment_type !== "english_v4" &&
          this.app_eng_assessment.assessment_type !== "english_v5" &&
          this.app_eng_assessment.assessment_type !== "english_genx_easy_v1" &&
          this.app_eng_assessment.assessment_type !==
            "english_genx_medium_v1" &&
          this.app_eng_assessment.assessment_type !== "english_technician_v1" &&
          this.app_eng_assessment.assessment_type !==
            "english_lead_technician_v1" &&
          this.app_eng_assessment.assessment_type !==
            "english_assistant_engineer_v1"
        )
          return;
        // Lazy import to avoid bundling if not needed

        const { fetch_assessment_answers } = await import(
          "@/store/apis/candidate"
        );
        const assessment_id = this.app_eng_assessment?.id;
        if (!assessment_id) return;
        const response = await fetch_assessment_answers(assessment_id, {
          user_id: this.get_user.id
        });
        const answers = response?.data?.data || [];
        answers.forEach((ans: unknown) => {
          const a = ans as Record<string, unknown>;
          // Filter out placeholder answers (created by backend for incomplete assessments)
          // and ensure answer is not empty
          const isValidAnswer =
            a?.answer &&
            String(a.answer) !== "......." &&
            String(a.answer).trim() !== "";

          if (a?.question_id && isValidAnswer)
            this.answered_question_ids = [
              ...new Set([...this.answered_question_ids, Number(a.question_id)])
            ];
        });
      } catch (e) {
        // Silently fail; progress will build as user answers
      }
    },

    /**
     * Fetch answers from backend and merge into current state.
     * Ensures records are up to date when resuming (backend is source of truth for submitted answers).
     */
    async load_and_merge_backend_answers() {
      try {
        const { fetch_assessment_answers } = await import(
          "@/store/apis/candidate"
        );
        const assessment_id = this.app_eng_assessment?.id;
        if (!assessment_id || !this.get_user?.id) return;
        const response = await fetch_assessment_answers(assessment_id, {
          user_id: this.get_user.id,
          page: 0,
          limit: 500,
          allowPagination: 1
        });
        const data = response?.data?.data;
        const answers = Array.isArray(data) ? data : data?.results || [];
        if (!Array.isArray(answers) || answers.length === 0) return;

        const answersByQuestion = new Map<
          number,
          { answer: any; answer_type: string }
        >();
        answers.forEach((ans: any) => {
          if (
            ans?.question_id &&
            ans?.answer &&
            String(ans.answer) !== "......."
          )
            answersByQuestion.set(Number(ans.question_id), {
              answer: ans.answer,
              answer_type: ans.answer_type || "text"
            });
        });

        // Update answered_question_ids
        answersByQuestion.forEach((_, qId) => {
          if (!this.answered_question_ids.includes(qId))
            this.answered_question_ids = [...this.answered_question_ids, qId];
        });

        // Merge into childStates by section
        const eng = this.app_eng_assessment as any;
        if (!this.childStates) this.childStates = {};

        // Written section: question index -> answer
        if (Array.isArray(eng?.written)) {
          const written = this.childStates.written || {
            current_question_index: 0,
            answers: {}
          };
          if (!written.answers) written.answers = {};
          eng.written.forEach((q: any, idx: number) => {
            const data = answersByQuestion.get(Number(q?.id));
            if (data)
              written.answers[idx] =
                typeof data.answer === "string"
                  ? data.answer
                  : JSON.stringify(data.answer);
          });
          this.childStates.written = written;
          this.writtenRestoredState = written;
        }

        // Build or merge reading state from backend answers
        const buildReadingFromBackend = () => {
          const questions = eng?.reading_questions || [];
          if (!Array.isArray(questions) || questions.length === 0) return null;
          const answersMap: Record<
            number,
            Array<{ question_id: number; question_answer: string }>
          > = {};
          let maxPartWithAnswer = 0;
          questions.forEach((q: any) => {
            const part = q?.question_options?.part ?? 1;
            if (!answersMap[part]) answersMap[part] = [];
            const data = answersByQuestion.get(Number(q?.id));
            const ans = data
              ? typeof data.answer === "string"
                ? data.answer
                : JSON.stringify(data.answer)
              : "";
            answersMap[part].push({ question_id: q.id, question_answer: ans });
            if (ans) maxPartWithAnswer = Math.max(maxPartWithAnswer, part);
          });
          const currentPart = maxPartWithAnswer > 0 ? maxPartWithAnswer : 1;
          return {
            currentPart,
            answersMap,
            answers: answersMap[currentPart] || []
          };
        };
        const readingFromBackend = buildReadingFromBackend();
        if (readingFromBackend) {
          const existing = this.childStates.reading || {};
          this.childStates.reading = {
            ...existing,
            currentPart: existing.currentPart ?? readingFromBackend.currentPart,
            answersMap: {
              ...(readingFromBackend.answersMap || {}),
              ...(existing.answersMap || {})
            }
          };
          this.readingRestoredState = this.childStates.reading;
        }

        // Build or merge listening state from backend answers
        const buildListeningFromBackend = () => {
          const questions = eng?.listening_questions || [];
          if (!Array.isArray(questions) || questions.length === 0) return null;
          const answersMap: Record<
            number,
            Array<{ question_id: number; question_answer: string }>
          > = {};
          let maxPartWithAnswer = 0;
          questions.forEach((q: any) => {
            const part = q?.question_options?.part ?? 1;
            if (!answersMap[part]) answersMap[part] = [];
            const data = answersByQuestion.get(Number(q?.id));
            const ans = data
              ? typeof data.answer === "string"
                ? data.answer
                : JSON.stringify(data.answer)
              : "";
            answersMap[part].push({ question_id: q.id, question_answer: ans });
            if (ans) maxPartWithAnswer = Math.max(maxPartWithAnswer, part);
          });
          const currentPart = maxPartWithAnswer > 0 ? maxPartWithAnswer : 1;
          return { currentPart, answersMap };
        };
        const listeningFromBackend = buildListeningFromBackend();
        if (listeningFromBackend) {
          const existing = this.childStates.listening || {};
          // Preserve existing currentPart when user was on Part 2+ (backend only has submitted parts)
          const hasValidCurrentPart =
            existing.currentPart != null && Number(existing.currentPart) > 0;
          const mergedListening = {
            ...existing,
            currentPart: hasValidCurrentPart
              ? Number(existing.currentPart)
              : listeningFromBackend.currentPart ?? 1,
            answersMap: {
              ...(listeningFromBackend.answersMap || {}),
              ...(existing.answersMap || {})
            }
          };
          this.childStates.listening = mergedListening;
          this.listeningRestoredState = mergedListening;
        }

        if (this.childStates.grammar) {
          this.grammarRestoredState = { ...this.childStates.grammar };
        }

        this.persistCurrentState();
      } catch (e) {
        console.warn("Failed to merge backend answers on resume:", e);
      }
    },
    // Track answered question id(s) for english_v4/v5/genx (drives global progress bar)
    async track_answer(payload?: unknown) {
      if (
        this.app_eng_assessment.assessment_type !== "english_v4" &&
        this.app_eng_assessment.assessment_type !== "english_v5" &&
        this.app_eng_assessment.assessment_type !== "english_genx_easy_v1" &&
        this.app_eng_assessment.assessment_type !== "english_genx_medium_v1" &&
        this.app_eng_assessment.assessment_type !== "english_technician_v1" &&
        this.app_eng_assessment.assessment_type !==
          "english_lead_technician_v1" &&
        this.app_eng_assessment.assessment_type !==
          "english_assistant_engineer_v1"
      )
        return;

      // Prefer immediate local update (so progress moves as the user answers),
      // fall back to backend fetch if child didn't provide an id.
      const addId = (id: number) => {
        if (Number.isFinite(id) && id > 0) {
          if (!this.answered_question_ids.includes(id)) {
            this.answered_question_ids = [...this.answered_question_ids, id];
          }
        }
      };

      if (Array.isArray(payload)) {
        payload.forEach((raw) => {
          const id =
            typeof raw === "number"
              ? raw
              : Number((raw as any)?.question_id ?? (raw as any)?.id);
          addId(id);
        });
        return;
      }

      const singleId =
        typeof payload === "number"
          ? payload
          : Number((payload as any)?.question_id ?? (payload as any)?.id);
      if (Number.isFinite(singleId) && singleId > 0) {
        addId(singleId);
        return;
      }

      // As a safety net (e.g. legacy flows), reload from backend.
      await this.load_existing_answers();
    },
    async handle_global_time_over() {
      if (
        this.app_eng_assessment.assessment_type !== "english_v4" &&
        this.app_eng_assessment.assessment_type !== "english_v5" &&
        this.app_eng_assessment.assessment_type !== "english_genx_easy_v1" &&
        this.app_eng_assessment.assessment_type !== "english_genx_medium_v1" &&
        this.app_eng_assessment.assessment_type !== "english_technician_v1" &&
        this.app_eng_assessment.assessment_type !==
          "english_lead_technician_v1" &&
        this.app_eng_assessment.assessment_type !==
          "english_assistant_engineer_v1"
      )
        return;
      if (this.isOffline) {
        this.set_root_error(
          this.$t("assessments.reconnect-to-continue").toString()
        );
        return;
      }
      this.global_time_over = true;
      await this.submit_assessment_answers({
        assessment_id: this.app_eng_assessment.id,
        question_id: this.app_eng_assessment["reading_questions"][0]?.id || 0,
        answer_type: AppAssessments.QuestionType.JSON,
        answer: JSON.stringify({
          message: "Time over - auto submitting answers"
        }),
        done: true
      });
      this.set_app_eng_assessments({
        ...this.app_eng_assessment,
        cancelled: false,
        completed: true,
        done: true
      });
      localStorage.removeItem("stage");
      localStorage.removeItem("part_index");
      localStorage.removeItem("sub_question_index");
      this.process_assessment_completed();
    },
    on_reading_scenario_completed() {
      window.scrollTo({
        top: 0,
        behavior: "smooth" // optional, smooth scroll
      });
    },
    on_listening_scenario_completed() {
      window.scrollTo({
        top: 0,
        behavior: "smooth" // optional, smooth scroll
      });
    },
    // Triggered when Reading section emits assessment_completed
    on_reading_completed() {
      console.log("set_app_eng_assessments5");
      const listeningQuestions = (
        this.app_eng_assessment as { listening_questions?: unknown[] }
      ).listening_questions;
      const hasListening =
        Array.isArray(listeningQuestions) && listeningQuestions.length > 0;
      const nextStage = hasListening
        ? ViewAssessmentsOptions.LISTENING_QUESTIONS
        : ViewAssessmentsOptions.MCQS;
      this.set_app_eng_assessments({
        ...this.app_eng_assessment,
        filter: nextStage,
        assessment_type: this.app_eng_assessment.assessment_type
      });
      localStorage.setItem("stage", nextStage);
      this.increment_question_index(0);

      // Reset timers for the next section
      this.partTime = 0;
      this.questionTime = 0;
      this.startTimer("partTime");
      this.startTimer("questionTime");
    },
    on_listening_completed() {
      const nextStage =
        this.assessment_type === "english_v4" ||
        this.assessment_type === "english_v5" ||
        this.assessment_type === "english_genx_easy_v1" ||
        this.assessment_type === "english_genx_medium_v1" ||
        this.assessment_type === "english_technician_v1" ||
        this.assessment_type === "english_lead_technician_v1" ||
        this.assessment_type === "english_assistant_engineer_v1"
          ? ViewAssessmentsOptions.GRAMMAR
          : ViewAssessmentsOptions.MCQS;
      this.set_app_eng_assessments({
        ...this.app_eng_assessment,
        filter: nextStage,
        assessment_type: this.app_eng_assessment.assessment_type
      });
      localStorage.setItem("stage", nextStage);
      this.increment_question_index(0);

      this.partTime = 0;
      this.questionTime = 0;
      this.startTimer("partTime");
      this.startTimer("questionTime");
    },
    on_grammar_completed() {
      console.log("grammer comp");
      this.set_app_eng_assessments({
        ...this.app_eng_assessment,
        filter: ViewAssessmentsOptions.SPEAKING,
        assessment_type: this.app_eng_assessment.assessment_type
      });
      localStorage.setItem("stage", ViewAssessmentsOptions.SPEAKING);
      this.increment_question_index(0);

      this.partTime = 0;
      this.questionTime = 0;
      this.startTimer("partTime");
      this.startTimer("questionTime");
    },
    on_header_filter_change(filter: string) {
      if (
        this.assessment_type !== "english_v4" &&
        this.assessment_type !== "english_v5" &&
        this.assessment_type !== "english_genx_easy_v1" &&
        this.assessment_type !== "english_genx_medium_v1" &&
        this.assessment_type !== "english_technician_v1" &&
        this.assessment_type !== "english_lead_technician_v1" &&
        this.assessment_type !== "english_assistant_engineer_v1"
      ) {
        return;
      }
      this.set_app_eng_assessments({
        ...this.app_eng_assessment,
        filter,
        assessment_type: this.app_eng_assessment.assessment_type
      });
      localStorage.setItem("stage", filter);
      this.increment_question_index(0);
      this.partTime = 0;
      this.questionTime = 0;
      this.startTimer("partTime");
      this.startTimer("questionTime");
    },
    async check_stage() {
      const stage = localStorage.getItem("stage");
      console.log("set_app_eng_assessments6");
      if (
        stage &&
        stage !== ViewAssessmentsOptions.SPEAKING &&
        this.app_eng_assessment.assessment_type !== "english_v4" &&
        this.app_eng_assessment.assessment_type !== "english_v5" &&
        this.app_eng_assessment.assessment_type !== "english_genx_easy_v1" &&
        this.app_eng_assessment.assessment_type !== "english_genx_medium_v1" &&
        this.app_eng_assessment.assessment_type !== "english_technician_v1" &&
        this.app_eng_assessment.assessment_type !==
          "english_lead_technician_v1" &&
        this.app_eng_assessment.assessment_type !==
          "english_assistant_engineer_v1"
      ) {
        this.set_app_eng_assessments({
          filter: stage,
          speaking: this.app_eng_assessment.speaking,
          mcqs: this.app_eng_assessment.mcqs,
          written: this.app_eng_assessment.written,
          reading_questions: this.app_eng_assessment.reading_questions,
          listeneing_questions: this.app_eng_assessment.listening_questions,
          id: this.app_eng_assessment.id,
          assessment_type: this.app_eng_assessment.assessment_type
        });
        if (stage === ViewAssessmentsOptions.MCQS) {
          const storedArray = JSON.parse(
            localStorage.getItem("answers") || "[]"
          );
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          this.options = storedArray.map((item: any) =>
            item === null ? undefined : item
          );
          // console.log("this.options1:", this.options);
          // this.options = storedArray;
        }
      } else {
        localStorage.setItem("stage", this.app_eng_assessment.filter);
      }
    },
    async process_ans(
      //MCQs answers
      question_id: number,
      question_index: number,
      question_text: string,
      answer: string,
      correct_answer: string
    ) {
      if (this.isOffline) {
        this.set_root_error(
          this.$t("assessments.reconnect-to-continue").toString()
        );
        return;
      }
      this.submit_ans_loading = true;
      const current_result = answer === correct_answer ? true : false;
      this.options[question_index] = {
        question: question_text,
        question_index: question_index,
        answer: answer,
        result: current_result
      };

      const arrayFull = Array.from({
        length: this.app_eng_assessment.mcqs?.length
      }).every((_, index) => this.options[index] !== undefined);
      this.answeredMcqsCount = this.options.filter(
        (item) => item !== undefined && item !== null
      )?.length;
      this.disabled_mcqs1_question =
        this.answeredMcqsCount == this.app_eng_assessment.mcqs?.length
          ? false
          : true;
      const payload: UpdateAssessmentMcqsPayload = {
        filter: ViewAssessmentsOptions.MCQS,
        answer: answer,
        question_id: question_id
      };
      // Update localStorage with the new array
      localStorage.setItem(
        "stage",
        arrayFull ? ViewAssessmentsOptions.WRITING : payload.filter
      );
      localStorage.setItem(
        "question_id",
        !arrayFull ? payload.question_id.toString() : ""
      );

      !arrayFull
        ? localStorage.setItem("answers", JSON.stringify(this.options))
        : localStorage.setItem("answer", "");
      console.log("set_app_eng_assessments7");

      // console.log("payload", payload);
      this.set_app_eng_assessments({
        filter: ViewAssessmentsOptions.MCQS,
        mcqs_completed: arrayFull,
        mcqs: this.app_eng_assessment.mcqs,
        written: this.app_eng_assessment.written,
        reading_questions: this.app_eng_assessment.reading_questions,
        current_question_index: question_index,
        id: this.app_eng_assessment.id,
        assessment_type: this.app_eng_assessment.assessment_type
      });

      // const success =
      this.update_app_eng_assessment_questions(payload); // Update current question answer in store
      // console.log("Done store data: ", this.get_store_data.mcqs[0].answer);
      const mcqs_api_payload: SubmitAssessmentMcqsAnswersApiPayload = {
        answer: answer,
        question_id: question_id,
        answer_type: this.app_eng_assessment.mcqs[question_index].question_type,
        assessment_id:
          this.app_eng_assessment.mcqs[question_index].assessment_id
      };
      // console.log("API payload: ", mcqs_api_payload);
      const response = await this.submit_assessment_answers(mcqs_api_payload);

      this.set_assessment_average_time({
        answer_time: this.questionTime.toString()
      });
      this.questionTime = 0;
      this.startTimer("questionTime");
      if (!response) {
        this.set_root_error(`${this.$t("assessments.went-wrong")}`);
        this.submit_ans_loading = false;
        return;
      }

      this.submit_ans_loading = false;
      this.disabled_next_question = !arrayFull;
    },
    // startTimer(time: keyof Vue["$data"]) {
    //   setInterval(() => {
    //     (this as any)[time]++;
    //   }, 1000);
    // },
    startTimer(time: keyof Vue["$data"]) {
      // If a timer for this variable already exists, clear it first
      if (this.timers[time]) {
        clearInterval(this.timers[time]);
      }

      // Start a new interval and store the ID in the object
      this.timers[time] = setInterval(() => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (this as any)[time]++;
      }, 1000);
    },
    // Note: We intentionally avoid `beforeunload` prompts for assessments.
    // State is persisted via periodic auto-save + route-leave handlers.
    /**
     * Persist current assessment state to localStorage and backend.
     * Backend save is throttled to max 2/min (30s interval) unless forceBackend=true.
     */
    persistCurrentState(forceBackend = false) {
      if (!this.app_eng_assessment?.id || this.isRestoringSession) return;

      const state: Partial<AssessmentSessionState> = {
        assessment_id: this.app_eng_assessment.id,
        assessment_type: this.assessment_type,
        user_id: this.get_user?.id,
        stage: this.app_eng_assessment.filter,
        current_question_index: this.current_question_index,

        // Timer state
        assessmentTime: this.assessmentTime,
        partTime: this.partTime,
        questionTime: this.questionTime,
        english_assessment_timer: this.english_assessment_timer,
        english_assessment_time: this.english_assessment_time, // Total time for assessment
        global_time_over: this.global_time_over,

        // MCQs state
        mcqs: {
          options: this.options,
          answeredMcqsCount: this.answeredMcqsCount,
          mcqs_part1_completed: this.mcqs_part1_completed
        },

        // Speaking state
        speaking: {
          current_question_index: this.current_question_index,
          speaking_history: this.speaking_history,
          answered_question_ids: this.answered_question_ids
        },

        // Child component states
        childStates: this.childStates
      };

      AssessmentPersistenceService.saveState(this.app_eng_assessment.id, state);

      // Only create/update assessment result on backend when candidate has accepted terms AND shared camera + screen.
      // This prevents "Wait for Approval" when they deny terms or leave before sharing screen (assessment not started).
      const hasStartedAssessment =
        this.camera_media_enabled && this.media_enabled;
      if (!hasStartedAssessment) return;

      // Save to backend at most every 30s (2 requests per minute) unless forceBackend
      const minIntervalMs = 30 * 1000;
      const now = Date.now();
      if (forceBackend || now - this.lastBackendSaveAt >= minIntervalMs) {
        this.lastBackendSaveAt = now;
        this.save_assessment_state({
          assessment_id: this.app_eng_assessment.id,
          saved_state: state as Record<string, unknown>,
          time_spent: this.assessmentTime
        });
      }
    },

    /**
     * Restore assessment state from saved session
     */
    async restoreFromSavedState(state: AssessmentSessionState) {
      this.isRestoringSession = true;

      try {
        // Restore timers
        this.assessmentTime = state.assessmentTime || 0;
        this.partTime = state.partTime || 0;
        this.questionTime = state.questionTime || 0;
        this.english_assessment_timer = state.english_assessment_timer || 0;
        // english_assessment_time is the TOTAL time, not elapsed - restore it correctly
        // Fallback to localStorage if saved state has 0 (might be from older buggy version)
        const savedTotalTime = state.english_assessment_time || 0;
        const localStorageTotalTime =
          Number(localStorage.getItem("englishAssessmentTotalTime")) || 0;

        let totalTime =
          savedTotalTime > 0 ? savedTotalTime : localStorageTotalTime;

        // Fallback to assessment allowed_time if we have access to it and time is missing
        if (totalTime <= 0 && this.app_eng_assessment?.id) {
          const assessment = this.app_assessments.find(
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (item: any) => item.id === this.app_eng_assessment?.id
          );
          if (assessment?.allowed_time) {
            totalTime =
              assessment.allowed_time < 100
                ? assessment.allowed_time * 60
                : assessment.allowed_time;
            // Persist it for future reloads
            localStorage.setItem(
              "englishAssessmentTotalTime",
              String(totalTime)
            );
          }
        }

        this.english_assessment_time = totalTime;
        // Never restore global_time_over as true - if time was over, the session should have been cleared
        // Always start fresh and let the timer component determine if time is up
        this.global_time_over = false;

        // Calculate and set the remaining time for the timer component
        this.initialRemainingTime = Math.max(
          0,
          this.english_assessment_time - this.english_assessment_timer
        );
        // Increment key to force timer re-render with new remaining time
        this.timerKeyVersion++;

        // Restore Vuex state
        this.set_app_eng_assessments({
          ...this.app_eng_assessment,
          filter: state.stage
        });

        // Restore current question index
        if (state.current_question_index !== undefined) {
          this.increment_question_index(state.current_question_index);
        }

        // Restore MCQs state
        if (state.mcqs) {
          this.options = state.mcqs.options || [];
          this.answeredMcqsCount = state.mcqs.answeredMcqsCount || 0;
          this.mcqs_part1_completed = state.mcqs.mcqs_part1_completed || false;
        }

        // Restore speaking state
        if (state.speaking) {
          this.speaking_history = state.speaking.speaking_history || [];
          this.answered_question_ids =
            state.speaking.answered_question_ids || [];
        }

        // Restore child component states
        if (state.childStates) {
          this.childStates = state.childStates;
          this.readingRestoredState = state.childStates.reading || null;
          this.listeningRestoredState = state.childStates.listening || null;
          this.grammarRestoredState = state.childStates.grammar || null;
          this.writtenRestoredState = state.childStates.written || null;
        }

        // Update localStorage for legacy compatibility
        localStorage.setItem("stage", state.stage);
        // englishAssessmentTimer in localStorage stores TOTAL time, not elapsed
        localStorage.setItem(
          "englishAssessmentTimer",
          String(state.english_assessment_time || 0)
        );

        console.log("Assessment state restored from saved session");
      } finally {
        this.isRestoringSession = false;
      }
    },

    /**
     * Handle child component state changes for persistence
     */
    handleChildStateChange({
      section,
      state
    }: {
      section: string;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      state: any;
    }) {
      // For written section: merge answers so we don't lose previous question answers
      if (section === "written" && state?.answers) {
        const existing = this.childStates.written?.answers || {};
        state.answers = { ...existing, ...state.answers };
      }
      this.childStates[section] = state;
      // Save to localStorage immediately; backend save is throttled (30s) in persistCurrentState
      this.persistCurrentState();
    },

    /**
     * Handle coming back online
     */
    async handleOnline() {
      this.isOffline = false;

      // Sync any pending answers
      if (this.app_eng_assessment?.id) {
        const pending = AssessmentPersistenceService.getPendingAnswers(
          this.app_eng_assessment.id
        );

        if (pending.length > 0) {
          console.log(`Syncing ${pending.length} pending answers...`);
          for (const answer of pending) {
            try {
              await this.submit_assessment_answers(answer);
            } catch (e) {
              console.error("Failed to sync pending answer:", e);
            }
          }
          AssessmentPersistenceService.clearPendingAnswers(
            this.app_eng_assessment.id
          );
        }
      }
    },

    /**
     * Handle going offline
     */
    handleOffline() {
      this.isOffline = true;
      if (!this.assessment_completed) {
        this.set_root_error(
          this.$t("assessments.internet-disconnected").toString()
        );
      }
      // Save state immediately when going offline
      this.persistCurrentState();
    },

    /**
     * Handle tab visibility changes.
     * If the tab is moved to background while the English assessment is active,
     * immediately save state, stop all media, and return the candidate to dashboard
     * instead of silently continuing (or re-requesting permissions) in the background.
     */
    handleVisibilityChange() {
      if (
        typeof document === "undefined" ||
        document.visibilityState !== "hidden" ||
        this.assessment_completed ||
        this.assessment_cancelled
      ) {
        return;
      }

      // Persist latest state (including timers) so resume flows can work if allowed.
      try {
        this.persistCurrentState(true);
      } catch (e) {
        // ignore persistence failures; navigation below still enforces exit
      }

      // Mark that we're intentionally leaving so screen-share revoke handlers
      // don't try to re-request permissions while exiting.
      this.isNavigatingAway = true;

      // Stop all active media immediately so recording does not continue in background
      try {
        this.stopAllMediaStreams();
      } catch (e) {
        // ignore
      }

      // Surface a clear message so the candidate understands why they were exited
      this.set_root_error(
        "Your English assessment session was closed because the browser tab was moved to the background."
      );

      // Navigate away from the assessment so it cannot continue in a hidden tab
      this.$router.push("/candidate/dashboard");
    },

    // Function to intiatia whole process
    async play_questionMedia(index: string) {
      this.canSelect = false;
      const question: any = this.app_eng_assessment.speaking[index] || null;
      const question_url: any = question
        ? question.question_options.question_voice_url
        : null;
      // console.log("question: ", question);
      this.push_chat_history_obj(
        question.question_text,
        this.format_chat_date(),
        this.bot_image
      );
      await wait_until(1500);
      if (question.question_options && question_url) {
        await this.playAudio(question_url);
      }
      // console.log("Stoped");
    },
    goToDashboard() {
      // Mark that we're intentionally leaving this screen so that any
      // media "ended" events don't trigger permission recovery flows.
      this.isNavigatingAway = true;
      // Ensure all media/recording is stopped before navigating away
      try {
        this.stopAllMediaStreams();
      } catch (e) {
        // ignore
      }
      // Cancel any in-progress attempt when leaving without completing permissions
      // (e.g. cancelled screen share) so dashboard shows "Start assessment" not "Wait for Approval"
      const assessmentId = this.app_eng_assessment?.id;
      if (assessmentId != null) {
        cancel_my_assessment_attempt(assessmentId).catch(() => {
          // Non-blocking: still navigate so user sees dashboard
        });
      }
      this.$router.push("/candidate/dashboard");
    },
    /** Reload and navigate to dashboard screen */
    reloadForPermissions() {
      window.location.href = "/candidate/dashboard";
    },
    async init_process() {
      this.loading = true;
      try {
        // Screen recording is not supported on iOS Safari (getDisplayMedia unsupported)
        if (isIOS()) {
          this.error = this.$t("assessments.browser-unsupport").toString();
          this.loading = false;
          this.set_screen_recording_supported(false);
          return;
        }
        await this.invokeCamera();
        if (this.error) {
          this.loading = false;
          return;
        }
        if (!this.camera_media_stream || !this.camera_media_recorder) {
          this.loading = false;
          return;
        }
        this.camera_media_enabled = true;

        await this.invokeGetDisplayMedia();
        if (this.error) {
          this.loading = false;
          return;
        }
        if (!this.media_stream) {
          this.loading = false;
          return;
        }
        this.media_enabled = true;
        this.loading = false;

        // Get assessment type first
        const assessment = this.app_assessments.find(
          (item: any) => item.id === this.app_eng_assessment?.id
        );
        this.assessment_type = assessment.assessment_type;

        // Check for saved session state (localStorage only - for resume after reload/close/crash)
        const savedState = AssessmentPersistenceService.loadState(
          this.app_eng_assessment?.id
        );

        // Validate saved state before restoring
        const shouldRestore =
          savedState &&
          savedState.user_id === this.get_user?.id &&
          // Don't restore if assessment is already completed/attempted
          assessment?.status !== "attempted" &&
          assessment?.status !== "completed" &&
          // Don't restore if the saved session had time expired
          !savedState.global_time_over;

        if (!shouldRestore && savedState) {
          // Clear stale saved state
          console.log(
            "Clearing stale assessment session (status:",
            assessment?.status,
            ", global_time_over:",
            savedState.global_time_over,
            ")"
          );
          AssessmentPersistenceService.clearState(this.app_eng_assessment?.id);
        }

        let stateToRestore = savedState;
        if (
          !shouldRestore &&
          !savedState &&
          assessment?.status !== "attempted"
        ) {
          // No localStorage (e.g. different device) - try backend saved_state
          const result = await this.$store.dispatch(
            `common/${APP_ASSESSMENT_RESULT}`,
            { assessment_id: this.app_eng_assessment.id }
          );
          const backendState = (result as any)?.result?.saved_state;
          if (backendState && backendState.user_id === this.get_user?.id) {
            stateToRestore = backendState;
          }
        }

        if (stateToRestore && stateToRestore.user_id === this.get_user?.id) {
          console.log("Found valid assessment session, restoring...");
          await this.restoreFromSavedState(stateToRestore);

          // Load backend answers and merge (source of truth for submitted answers)
          await this.load_and_merge_backend_answers();

          // Start timers after restoration
          this.startTimer("assessmentTime");
          this.startTimer("partTime");
          this.startTimer("questionTime");

          // Setup speaking questions if needed
          if (
            this.assessment_type === "english_v3" ||
            this.assessment_type === "english_v4" ||
            this.assessment_type === "english_v5" ||
            this.assessment_type === "english_genx_easy_v1" ||
            this.assessment_type === "english_genx_medium_v1" ||
            this.assessment_type === "english_technician_v1" ||
            this.assessment_type === "english_lead_technician_v1" ||
            this.assessment_type === "english_assistant_engineer_v1"
          ) {
            this.speaking_questions = this.app_eng_assessment.speaking.map(
              (question: any, index: number) => ({
                value: index,
                text: question.question_text
              })
            );
          }
          return; // Skip normal initialization
        }

        // Normal initialization (no saved session)
        let stage = localStorage.getItem("stage");

        if (
          this.assessment_type === "english_v4" ||
          this.assessment_type === "english_v5" ||
          this.assessment_type === "english_genx_easy_v1" ||
          this.assessment_type === "english_genx_medium_v1" ||
          this.assessment_type === "english_technician_v1" ||
          this.assessment_type === "english_lead_technician_v1" ||
          this.assessment_type === "english_assistant_engineer_v1"
        ) {
          // Fallback: Ensure total time is set from assessment config if missing in localStorage
          let currentTotalTime =
            Number(localStorage.getItem("englishAssessmentTotalTime")) || 0;
          if (currentTotalTime <= 0 && assessment?.allowed_time) {
            // Heuristic: If time < 100, assume minutes and convert to seconds. Otherwise assume seconds.
            // This handles common cases like 30, 45, 60 minutes vs 1800, 2700, 3600 seconds
            currentTotalTime =
              assessment.allowed_time < 100
                ? assessment.allowed_time * 60
                : assessment.allowed_time;
            localStorage.setItem(
              "englishAssessmentTotalTime",
              String(currentTotalTime)
            );
            this.english_assessment_time = currentTotalTime;
          }
        }

        if (
          (stage === null && this.assessment_type === "english_v3") ||
          this.assessment_type === "english_v4" ||
          this.assessment_type === "english_v5" ||
          this.assessment_type === "english_genx_easy_v1" ||
          this.assessment_type === "english_genx_medium_v1" ||
          this.assessment_type === "english_technician_v1" ||
          this.assessment_type === "english_lead_technician_v1" ||
          this.assessment_type === "english_assistant_engineer_v1"
        ) {
          localStorage.setItem("stage", ViewAssessmentsOptions.MCQS);
          stage = ViewAssessmentsOptions.MCQS;
        }

        // Timer procedure - restore from localStorage but DON'T remove
        // (keeps values for multi-reload support)
        const assessmentTime =
          Number(localStorage.getItem("assessmentTime")) || 0;
        if (assessmentTime > 0) {
          this.assessmentTime = assessmentTime;
        }

        const partTime = Number(localStorage.getItem("partTime")) || 0;
        if (partTime > 0) {
          this.partTime = partTime;
        }

        const questionTime = Number(localStorage.getItem("questionTime")) || 0;
        if (questionTime > 0) {
          this.questionTime = questionTime;
        }

        this.startTimer("assessmentTime");
        this.startTimer("partTime");
        this.startTimer("questionTime");

        // Restore MCQ answers from localStorage if available
        const savedAnswers = localStorage.getItem("answers");
        if (savedAnswers) {
          try {
            this.options = JSON.parse(savedAnswers);
            this.answeredMcqsCount = this.options.filter(
              (opt: any) => opt !== null && opt !== undefined
            ).length;
          } catch (e) {
            console.warn("Failed to restore MCQ answers:", e);
          }
        }

        if (
          (!stage || stage === "SPEAKING") &&
          (this.assessment_type === "english_v3" ||
            this.assessment_type === "english_v4" ||
            this.assessment_type === "english_v5" ||
            this.assessment_type === "english_genx_easy_v1" ||
            this.assessment_type === "english_genx_medium_v1" ||
            this.assessment_type === "english_technician_v1" ||
            this.assessment_type === "english_lead_technician_v1" ||
            this.assessment_type === "english_assistant_engineer_v1")
        ) {
          if (!stage) {
            localStorage.setItem("stage", this.app_eng_assessment.filter);
          }
          this.speaking_questions = this.app_eng_assessment.speaking.map(
            (question: any, index: number) => ({
              value: index,
              text: question.question_text
            })
          );
        } else if (
          (!stage || stage === "SPEAKING") &&
          this.assessment_type !== "english_v3" &&
          this.assessment_type !== "english_v4" &&
          this.assessment_type !== "english_v5" &&
          this.assessment_type !== "english_genx_easy_v1" &&
          this.assessment_type !== "english_genx_medium_v1" &&
          this.assessment_type !== "english_technician_v1" &&
          this.assessment_type !== "english_lead_technician_v1" &&
          this.assessment_type !== "english_assistant_engineer_v1"
        ) {
          const question =
            this.app_eng_assessment.speaking[this.current_question_index];
          this.push_chat_history_obj(
            question.question_text,
            this.format_chat_date(),
            this.bot_image
          );
          await wait_until(1000);
          if (
            question.question_options &&
            question.question_options.question_voice_url
          ) {
            await this.playAudio(question.question_options.question_voice_url);
          }
        }

        // Save initial state
        this.persistCurrentState();
      } catch (error) {
        console.log({ error });

        this.error = this.$t("assessments.unable-access").toString();
      }
    },
    // Function to invoke screen recording permission from user and start recording
    async invokeGetDisplayMedia() {
      // Check if browser supports screen recording
      if (navigator?.mediaDevices?.getDisplayMedia) {
        try {
          // Ask for screen recording permission (Safari 16+ supports preferCurrentTab)
          const displayOptions = {
            video: true,
            audio: true,
            ...(isSafari() && { preferCurrentTab: true })
          };
          this.media_stream = await navigator.mediaDevices.getDisplayMedia(
            displayOptions
          );
          if (!this.media_stream) return;
          // Detect when user revokes screen share in browser settings during assessment
          this.media_stream.getTracks().forEach((track) => {
            track.addEventListener("ended", this.handleScreenShareRevoked);
          });
          this.screen_recorder = new MediaRecorder(this.media_stream); // Create a media recorder
          this.screen_recorder.start(15000); // Start recording
          this.screen_recroding_start_time = new Date(); // Set camera recording start time
          // ondataavailable event will be triggered when there is data available
          this.screen_recorder.ondataavailable = (event) => {
            if (event.data.size > 0) {
              this.screen_recoding_chunks.push(event.data);
            }
            // If the screen recording stops unexpectedly *while the user is still logged in*
            // and the assessment is active, show an error and re-request permissions.
            // When the user has logged out (get_user is null) or is intentionally navigating
            // away (Go Back / dashboard), we silently ignore this so we don't pop permission
            // dialogs while leaving the page.
            if (
              this.get_user &&
              !this.isNavigatingAway &&
              !this.assessment_cancelled &&
              !this.assessment_completed &&
              !this.is_completing_assessment &&
              this.screen_recorder?.state !== "recording"
            ) {
              this.set_root_error(`${this.$t("assessments.share-screen")}`);
              this.invokeGetDisplayMedia();
              return;
            }
            if (
              this.screen_recoding_chunks.reduce(
                (sum, chunk) => sum + chunk.size,
                0
              ) >= this.screen_recording_upload_chuk_size
            ) {
              this.upload_recording_chunks(AssessmentRecordType.SCREEN);
            }
          };
          // onstop event will be triggered when user stops recording
          this.screen_recorder.onstop = () => {
            if (this.screen_recorder) {
              this.screen_recorder.stream
                .getTracks()
                .forEach((track) => track.stop());
              this.screen_recorder.ondataavailable = null;
              this.screen_recorder.onstop = null;
              this.screen_recorder = null;
              this.media_stream = null;
              this.screen_recroding_end_time = new Date(); // Set camera recording end time
            }
          };
          this.set_screen_recording_supported(true);
        } catch (error) {
          this.media_enabled = false;
          this.media_stream = null;
          this.screen_recorder = null;
        }
      } else {
        this.error = this.$t("assessments.browser-unsupport").toString();
        this.media_enabled = false;
        this.media_stream = null;
        this.screen_recorder = null;
        this.set_screen_recording_supported(false);
        this.loading = false;
      }
    },
    async invokeCamera() {
      if (!navigator?.mediaDevices?.getUserMedia) {
        this.error = this.$t("assessments.browser-unsupport-camera").toString();
        this.camera_media_stream = null;
        this.audio_media_stream = null;
        this.speech_recognition = null;
        this.camera_media_recorder = null;
        this.loading = false;
        this.set_camera_recording_supported(false);
        return;
      }

      try {
        const userMediaConstraints = {
          video: isSafari() ? { facingMode: "user" } : true,
          audio: true
        };
        const stream = await navigator.mediaDevices.getUserMedia(
          userMediaConstraints
        );

        if (stream && stream.getTracks()?.length > 0) {
          this.camera_media_stream = stream;
          this.audio_media_stream = stream;

          // Configure optional features safely
          if (
            "webkitSpeechRecognition" in window ||
            "SpeechRecognition" in window
          ) {
            await this.config_speech_recognition();
          }

          await this.config_video_recording(stream);
          this.set_camera_recording_supported(true);
          // Detect when user revokes camera or mic in browser settings (handle separately)
          stream.getTracks().forEach((track) => {
            track.addEventListener("ended", () =>
              this.handleCameraOrMicRevoked(track)
            );
          });
        } else {
          throw new Error("No active tracks found in stream");
        }
      } catch (e) {
        console.error("Camera initialization failed:", e);
        const err = e as { name?: string } | null;
        this.camera_media_stream = null;
        this.audio_media_stream = null;
        this.speech_recognition = null;
        this.camera_media_recorder = null;
        if (
          err?.name === "NotFoundError" ||
          err?.name === "DevicesNotFoundError"
        ) {
          this.error = this.$t("assessments.no-camera-device").toString();
        } else {
          this.error = this.$t("assessments.permission-denied").toString();
        }
        this.set_camera_recording_supported(false);
      }
    },
    async config_speech_recognition() {
      try {
        const speech_recognition = window.webkitSpeechRecognition;
        this.speech_recognition = new speech_recognition();
        this.speech_recognition.interimResults = true;
        this.speech_recognition.continuous = true;
        this.speech_recognition.onresult = this.handle_user_speech;
      } catch (e) {
        throw this.$t("assessments.no-speech-recognition");
      }
    },
    // eslint-disable-next-line no-undef
    handle_user_speech(result: any) {
      this.transcript = Array.from(result.results)
        // eslint-disable-next-line no-undef
        .map((result: any) => {
          if (result.isFinal) return result[0].transcript;
        })
        .join("");
    },
    async config_video_recording(stream: MediaStream) {
      try {
        const mimeTypes = getMediaRecorderMimeTypes();
        let options: { mimeType?: string } = {};
        for (const mimeType of mimeTypes) {
          if (MediaRecorder.isTypeSupported(mimeType)) {
            options = { mimeType };
            break;
          }
        }

        this.camera_media_recorder = new MediaRecorder(stream, options);
        this.camera_media_recorder.start(15000);
        this.camera_recording_start_time = new Date();

        // Only set video srcObject if the video element exists in the template
        const video = this.$refs.camera as HTMLVideoElement;
        if (video) {
          video.srcObject = stream;
        }

        this.camera_media_recorder.ondataavailable = this.media_recorder_data;
        this.camera_media_recorder.onstop = this.handle_media_recorder_stop;
        if (this.audio_media_stream)
          this.set_audio_recorder(this.audio_media_stream);
      } catch (e) {
        console.error("config_video_recording error details:", e);
        throw this.$t("assessments.unable-record");
      }
    },
    handleCameraOrMicRevoked(track: MediaStreamTrack) {
      if (
        this.media_stopped ||
        this.assessment_completed ||
        this.assessment_cancelled
      )
        return;
      const stream = this.camera_media_stream;
      const videoLive =
        stream?.getVideoTracks().some((t) => t.readyState === "live") ?? false;
      const audioLive =
        stream?.getAudioTracks().some((t) => t.readyState === "live") ?? false;

      const msgCamera = this.$t(
        "assessments.permission-revoked-camera"
      ).toString();
      const msgMic = this.$t("assessments.permission-revoked-mic").toString();
      const msgBoth = this.$t("assessments.permission-revoked").toString();

      let msg = msgBoth;
      if (track.kind === "audio") {
        msg = videoLive ? msgMic : msgBoth;
      } else if (track.kind === "video") {
        msg = audioLive ? msgCamera : msgBoth;
      }

      this.error = msg;
      this.set_root_error(msg);
      if (track.kind === "video" || !videoLive) {
        this.set_camera_recording_supported(false);
      }
    },
    handleScreenShareRevoked() {
      // If the user has logged out (auth store user cleared) OR is intentionally
      // navigating away (Go Back / dashboard), ignore revoked screen sharing so
      // we don't show error overlays or permission prompts while leaving.
      if (!this.get_user || this.isNavigatingAway) return;
      if (!this.assessment_completed && !this.assessment_cancelled) {
        const msg = this.$t("assessments.permission-revoked").toString();
        this.error = msg;
        this.set_root_error(msg);
        this.set_screen_recording_supported(false);
      }
    },
    handle_media_recorder_stop() {
      if (this.camera_media_recorder) {
        this.camera_media_recorder.stream
          .getTracks()
          .forEach((track) => track.stop());
        console.log("Stopping media");
        this.camera_media_recorder.ondataavailable = null;
        this.camera_media_recorder.onstop = null;
        this.camera_media_recorder = null;
        this.camera_media_stream = null;
        this.audio_media_stream = null;
        this.media_stopped = true;
        this.camera_recording_end_time = new Date();
        console.log(
          "Media stopped - Assessment Type:",
          this.assessment_type,
          "Assessment Completed:",
          this.assessment_completed
        );

        // For english_v4, trigger completion after media is fully stopped
        // Only if assessment is actually being completed (not just media stopping unexpectedly)
        if (
          (this.assessment_type === "english_v4" ||
            this.assessment_type === "english_v5" ||
            this.assessment_type === "english_genx_easy_v1" ||
            this.assessment_type === "english_genx_medium_v1" ||
            this.assessment_type === "english_technician_v1" ||
            this.assessment_type === "english_lead_technician_v1" ||
            this.assessment_type === "english_assistant_engineer_v1") &&
          (this.assessment_completed || this.is_completing_assessment)
        ) {
          console.log("Triggering process_assessment_completed for english_v4");
          this.process_assessment_completed();
        } else if (
          this.get_screen_recording_supported &&
          this.get_camera_recording_supported &&
          this.assessment_completed
        ) {
          this.process_assessment_completed();
        }
      }
    },
    async media_recorder_data(data: BlobEvent) {
      if (data.data && data.data.size > 0) {
        this.camera_recorded_blobs.push(data.data);
      }
      if (
        this.camera_recorded_blobs.reduce(
          (sum, chunk) => sum + chunk.size,
          0
        ) >= this.camera_recording_upload_chuk_size
      ) {
        this.upload_recording_chunks(AssessmentRecordType.CAMERA);
      }
    },
    speak_config() {
      const userAudioElement = this.$refs.userAudio as HTMLAudioElement;
      if (userAudioElement) {
        userAudioElement.load();
        userAudioElement.pause();
      }
      if (!this.speech_recognition) {
        this.speech_mode = false;
        this.set_root_error(`${this.$t("assessments.no-speech-recognition")}`);
        return;
      }
      if (this.speech_mode) {
        this.speech_mode = false;
        wait_until(1000);
        this.speech_recognition.stop();
        this.audio_recorder?.pause();
        if (this.audio_media_stream) {
          const audioTrack = this.audio_media_stream.getAudioTracks()[0];
          if (audioTrack) {
            audioTrack.enabled = false;
          }
        }
        this.pauseRecording();
      } else {
        this.speech_mode = true;
        this.transcript = "";
        this.speech_recognition.start();
        if (this.audio_recorder && this.audio_recorder.state === "inactive") {
          this.start_recording();
          this.audio_recorder.start(100);
        } else {
          if (this.audio_recorder) {
            this.audio_recorder.resume();
            this.resumeRecording();
          }
        }
        if (this.audio_media_stream) {
          const audioTrack = this.audio_media_stream.getAudioTracks()[0];
          if (audioTrack) {
            audioTrack.enabled = true;
          }
        }
      }
    },
    format_chat_date(date: number = moment.now()): string {
      return moment(date).format("ddd, h:mm A").toString();
    },
    push_chat_history_obj(
      content: string,
      created_at: string,
      picture: string,
      role: AssessmentChatRoles = AssessmentChatRoles.BOT,
      id: number = generate_random_key(),
      audio_url?: string | null,
      time = ""
    ) {
      this.speaking_history.push({
        content,
        role,
        picture,
        created_at,
        id,
        audio_url,
        time
      });
    },
    async playAudio(file: string) {
      this.ttsAudio = new Audio(file);
      const video: HTMLVideoElement = this.$refs.video as HTMLVideoElement;
      video.muted = true;
      video.loop = true;
      await video.play();
      await this.ttsAudio.play();
      // if (this.canSelect === false) {
      //   await this.clear_audio_rec();
      // }
      this.ttsAudio.onended = async () => {
        this.bot_speaking = false;
        video.pause();
        video.currentTime = 0;
        this.transcript = "";
        // this.speak_config();
      };
      // this.update(video);
    },
    // Function to get text field message based on  bot speaking
    text_field_msg() {
      if (this.bot_speaking) {
        return this.$t("candidate.interview.speak").toString();
      } else return this.$t("candidate.interview.listening").toString();
    },
    complete_mcqs_part1() {
      this.mcqs_part1_completed = true;
      console.log("mcqs_part1_completed: ", this.mcqs_part1_completed);
    },
    async send_mcqs_response() {
      this.set_app_eng_assessments({
        filter:
          this.app_eng_assessment.assessment_type === "english_v4"
            ? ViewAssessmentsOptions.MCQS
            : ViewAssessmentsOptions.WRITING,
        mcqs_completed: true,
        completed:
          this.app_eng_assessment.assessment_type === "english_v4" ||
          this.app_eng_assessment.assessment_type === "english_v5" ||
          this.app_eng_assessment.assessment_type === "english_genx_easy_v1" ||
          this.app_eng_assessment.assessment_type ===
            "english_genx_medium_v1" ||
          this.app_eng_assessment.assessment_type === "english_technician_v1" ||
          this.app_eng_assessment.assessment_type ===
            "english_lead_technician_v1" ||
          this.app_eng_assessment.assessment_type ===
            "english_assistant_engineer_v1"
            ? true
            : false,
        mcqs: this.app_eng_assessment.mcqs,
        written: this.app_eng_assessment.written,
        reading_questions: this.app_eng_assessment.reading_questions,
        id: this.app_eng_assessment.id,
        assessment_type: this.app_eng_assessment.assessment_type
      });
      this.set_assessment_average_time({
        mcqs_time: this.partTime.toString()
      });
      this.questionTime = 0;
      this.partTime = 0;
      this.startTimer("partTime");
      this.startTimer("questionTime");
      if (
        this.app_eng_assessment.assessment_type === "english_v4" ||
        this.app_eng_assessment.assessment_type === "english_v5" ||
        this.app_eng_assessment.assessment_type === "english_genx_easy_v1" ||
        this.app_eng_assessment.assessment_type === "english_genx_medium_v1" ||
        this.app_eng_assessment.assessment_type === "english_technician_v1" ||
        this.app_eng_assessment.assessment_type ===
          "english_lead_technician_v1" ||
        this.app_eng_assessment.assessment_type ===
          "english_assistant_engineer_v1"
      ) {
        // Force progress to 100% before navigating
        this.global_progress = 100;
        this.is_completing_assessment = true;
        this.set_root_notification(
          `${this.$t("assessments.assessment-completed")}`
        );
        await new Promise((r) => setTimeout(r, 500));
        this.$router.push("/candidate/dashboard");
      }
    },
    // Function to send user response to server and process next question
    async send_user_response() {
      if (this.isOffline) {
        this.set_root_error(
          this.$t("assessments.reconnect-to-continue").toString()
        );
        return;
      }
      this.submit_ans_loading = true;
      this.audio_recorder?.stop();
      // If user is speaking then stop speech recognition
      if (this.speech_mode) {
        this.speech_mode = false; // Set speech mode to false
        this.speech_recognition.stop(); // Stop speech recognition
        this.audio_recorder?.stop();
        this.construct_audio_url();
      }
      this.bot_speaking = true; // Set bot speaking to true
      this.bot_ans_loading = true; // Set bot answering to true
      const answer = this.transcript; // Get user answer
      this.push_chat_history_obj(
        answer,
        this.format_chat_date(),
        this.get_user.avatar_uri,
        AssessmentChatRoles.USER,
        generate_random_key(),
        this.individual_ans_blob
          ? URL.createObjectURL(this.individual_ans_blob)
          : null,
        this.elapsedTime
      );
      this.stopRecording();
      await this.update_chat_cursor(); // Update cursor of chat box
      // Update current question answer in store
      const payload: UpdateAssessmentQuestionPayload = {
        filter: this.app_eng_assessment.filter,
        answer: this.transcript,
        question_id:
          this.app_eng_assessment.speaking[this.current_question_index].id
      };
      this.update_app_eng_assessment_questions(payload); // Update current question answer in store

      localStorage.setItem(
        "stage",
        this.assessment_type === "english_v3" ||
          this.assessment_type === "english_v4" ||
          this.assessment_type === "english_v5" ||
          this.assessment_type === "english_genx_easy_v1" ||
          this.assessment_type === "english_genx_medium_v1" ||
          this.assessment_type === "english_technician_v1" ||
          this.assessment_type === "english_lead_technician_v1" ||
          this.assessment_type === "english_assistant_engineer_v1"
          ? ViewAssessmentsOptions.MCQS
          : payload.filter
      );
      localStorage.setItem("question_id", payload.question_id.toString());
      // Api Call to save current question answer
      const api_payload: SubmitAssessmentAnswersApiPayload = {
        answer: this.transcript,
        question_id:
          this.app_eng_assessment.speaking[this.current_question_index].id,
        answer_type:
          this.app_eng_assessment.speaking[this.current_question_index]
            .question_type,
        assessment_id:
          this.app_eng_assessment.speaking[this.current_question_index]
            .assessment_id
      };
      const response = await this.submit_assessment_answers(api_payload);
      if (!response) {
        this.set_root_error(`${this.$t("assessments.went-wrong")}`);
        this.submit_ans_loading = false;
        return;
      }
      const blob = this.individual_ans_blob;
      if (
        this.assessment_type !== "english_v3" &&
        this.assessment_type !== "english_v4" &&
        this.assessment_type !== "english_v5" &&
        this.assessment_type !== "english_genx_easy_v1" &&
        this.assessment_type !== "english_genx_medium_v1" &&
        this.assessment_type !== "english_technician_v1" &&
        this.assessment_type !== "english_lead_technician_v1" &&
        this.assessment_type !== "english_assistant_engineer_v1"
      ) {
        this.increment_question_index(this.current_question_index + 1); // Increment current question
        await this.process_question(); // Process next question from bot or enable written assessment if all questions are answered;
      } else {
        const msqsCompleted =
          this.app_eng_assessment.mcqs?.length < 1 ? true : false;
        const filter = msqsCompleted
          ? ViewAssessmentsOptions.WRITING
          : ViewAssessmentsOptions.MCQS;
        console.log("set_app_eng_assessments9");

        this.set_app_eng_assessments({
          filter: filter,
          speaking_completed: true,
          msqsCompleted: msqsCompleted,
          speaking: this.app_eng_assessment.speaking,
          mcqs: this.app_eng_assessment.mcqs,
          written: this.app_eng_assessment.written,
          reading_questions: this.app_eng_assessment.reading_questions,
          id: this.app_eng_assessment.id,
          assessment_type: this.app_eng_assessment.assessment_type
        });
      }
      this.user_ans_recorder_chunks = []; // Reset user answer recording chunks
      const userAudioElement = this.$refs.userAudio as HTMLAudioElement;
      userAudioElement.src = ""; // Reset user audio element
      this.individual_ans_blob = null; // Reset individual answer blob
      this.submit_ans_loading = false; // Set submit answer loading to false
      const ans_id = response.id;
      if (ans_id && blob) {
        const formData = new FormData();
        formData.append(
          "audio",
          blob,
          `${this.app_eng_assessment.speaking[0].assessment_id}_ans_${ans_id}.wav`
        );
        formData.append("answer_id", ans_id.toString());
        formData.append(
          "assessment_id",
          this.app_eng_assessment.speaking[0].assessment_id
        );
        await this.submit_assessment_ans_media(formData);
      }
    },
    // Function to process next question from bot or enable written assessment
    // if all questions are answered
    // else increment current question and process next question
    async process_question() {
      // If all questions are not answered then process next question
      if (
        this.current_question_index <=
        this.app_eng_assessment.speaking?.length - 1
      ) {
        // Get question
        const question =
          this.app_eng_assessment.speaking[this.current_question_index];
        // Push question in chat history
        this.push_chat_history_obj(
          question.question_text,
          this.format_chat_date(),
          this.bot_image
        );
        await this.update_chat_cursor(); // Update cursor of chat box
        this.bot_ans_loading = false; // Set bot answering to false
        this.transcript = ""; // Reset user answer
        // Play audio of question if available
        if (
          question.question_options &&
          question.question_options.question_voice_url
        ) {
          await this.playAudio(question.question_options.question_voice_url);
        }
      } else {
        // console.log("LAst question: ", this.app_eng_assessment.mcqs);
        const msqsCompleted =
          this.app_eng_assessment.mcqs?.length < 1 ? true : false;
        const filter = msqsCompleted
          ? ViewAssessmentsOptions.WRITING
          : ViewAssessmentsOptions.MCQS;
        console.log("set_app_eng_assessments10");

        this.set_app_eng_assessments({
          filter: filter,
          speaking_completed: true,
          msqsCompleted: msqsCompleted,
          speaking: this.app_eng_assessment.speaking,
          mcqs: this.app_eng_assessment.mcqs,
          written: this.app_eng_assessment.written,
          reading_questions: this.app_eng_assessment.reading_questions,
          id: this.app_eng_assessment.id,
          assessment_type: this.app_eng_assessment.assessment_type
        });
      }
    },
    // Function to update chat box cursor to bottom
    async update_chat_cursor() {
      await wait_until(1000); // Wait for 1 second
      const box = this.$refs.chat_box as HTMLDivElement; // Get chat box
      if (box) box.scrollTop = box.scrollHeight; // Set scroll top to scroll height
    },
    // Function to process assessment completion event
    // Upload screen recording and camera recording to server
    // Navigate to dashboard
    async process_assessment_completed() {
      // Prevent duplicate completion calls and prevent watcher from recalculating progress
      if (this.is_completing_assessment) {
        console.log("Assessment completion already in progress, skipping...");
        return;
      }
      this.is_completing_assessment = true;
      // Inform parent route guard that we are completing/submitting, so it
      // must not show the "Leave Assessment" dialog during the redirect.
      this.$emit("assessment_completed");

      // Force all progress bars to show 100% immediately
      this.global_progress = 100;
      if (this.app_eng_assessment.mcqs?.length > 0) {
        this.answeredMcqsCount = this.app_eng_assessment.mcqs.length;
      }

      // Wait for Vue to update the DOM with 100% progress before proceeding
      await this.$nextTick();
      console.log(
        "Progress bar updated to 100%",
        this.global_progress,
        this.is_completing_assessment
      );

      // Small delay to ensure progress bar is visually updated
      await new Promise((r) => setTimeout(r, 300));

      let payload = {
        writing_time: this.partTime.toString(),
        english_assessment_time: this.assessmentTime.toString(),
        answer_time: this.questionTime.toString()
      };
      this.set_assessment_average_time(payload);

      // Stop all media streams and recorders
      await this.stopAllMediaStreams();

      // Upload recording chunks
      await this.upload_recording_chunks(AssessmentRecordType.SCREEN);
      await this.upload_recording_chunks(AssessmentRecordType.CAMERA);

      // Clear the persistence session since assessment is complete
      if (this.app_eng_assessment?.id) {
        AssessmentPersistenceService.clearState(this.app_eng_assessment.id);
      }

      // Clear legacy localStorage keys
      localStorage.removeItem("questionTime");
      localStorage.removeItem("partTime");
      localStorage.removeItem("assessmentTime");
      localStorage.removeItem("stage");
      localStorage.removeItem("englishAssessmentTimer");
      localStorage.removeItem("answers");
      localStorage.removeItem("question_id");

      // Mark all answers as answered to keep progress at 100%
      try {
        const allIds = this.getGlobalQuestionIds();
        if (allIds.length > 0) {
          this.answered_question_ids = [...new Set(allIds)];
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn("Failed to set answered_question_ids on completion:", e);
      }

      this.set_root_notification(
        `${this.$t("assessments.assessment-completed")}`
      );
      // Mark this navigation as an explicit assessment submission so that
      // the route guard can distinguish it from a user simply leaving
      // mid-assessment (which should go to Admin Approval Required).
      const win = window as unknown as {
        __englishAssessmentSubmitted?: boolean;
      };
      win.__englishAssessmentSubmitted = true;
      await new Promise((r) => setTimeout(r, 1500));
      await this.$router.push("/candidate/dashboard");
    },
    // Set Title When Site Direction Change
    camera_enable_title() {
      return this.$t(
        "candidate.interview.permission.declined-title"
      ).toString();
    },
    screen_enable_title() {
      return this.$t(
        "candidate.interview.permission.declined-title1"
      ).toString();
    },
    async process_reshare_screen() {
      await this.invokeGetDisplayMedia();
      if (this.media_stream) {
        this.media_enabled = true;
        this.error = "";
      }
    },
    async uploadFileWithChunks(file: File, filename: string) {
      this.media_uploading = true; // Set media uploading to true
      let retry = 0;
      const chunkSize = 2 * 1024 * 1024; // 2MB chunk size
      let start = 0;
      // Loop until start is less than file size
      while (start < file.size) {
        let end = Math.min(start + chunkSize, file.size); // Get end index
        let chunk = file.slice(start, end); // Get chunk
        const formData = new FormData(); // Create a form data
        formData.append("file", chunk, filename); // Append chunk to form data
        // formData.append("start", start.toString()); // Append start index to form data
        formData.append("filename", filename); // Append file name to form data
        const response = await this.upload_file_chunk(formData); // Api call to upload file chunk
        if (response && retry < 15) {
          start = end; // If response exist then set start to end
          retry = 0;
          this.media_uploading_progress = Math.round((start / file.size) * 100); // Set media uploading progress
        } else if (retry >= 15) {
          this.set_root_error(`${this.$t("assessments.upload-file-error")}`);
          break;
        } else {
          retry += 1;
        }
      }
      this.media_uploading = false; // Set media uploading to false
      this.media_uploading_progress = 0; // Set media uploading progress to 0
      this.media_uploading_title = ""; // Set media uploading title to empty
    },
    construct_audio_url() {
      const userAudioElement = this.$refs.userAudio as HTMLAudioElement;
      try {
        if (this.user_ans_recorder_chunks?.length > 0 && userAudioElement) {
          this.individual_ans_blob = new Blob(this.user_ans_recorder_chunks, {
            type: "audio/wav"
          });
          const audioUrl = URL.createObjectURL(this.individual_ans_blob);
          userAudioElement.src = audioUrl;
          userAudioElement.load();
          // userAudioElement.play();
        }
      } catch (e) {
        // console.log(e, "e");
      }
    },
    set_audio_recorder(stream: MediaStream) {
      const audioTrack = stream.getAudioTracks()[0];
      this.audio_recorder = new MediaRecorder(new MediaStream([audioTrack]));
      this.user_ans_recorder_chunks = [];
      this.audio_recorder.ondataavailable = (event) => {
        if (audioTrack.enabled && event.data.size > 0) {
          this.user_ans_recorder_chunks.push(event.data);
          this.audio_recorder_chunks.push(event.data);
        }
      };
      this.audio_recorder.pause = () => {
        this.construct_audio_url();
      };
    },
    async clear_audio_rec() {
      // Get the parent element
      const userAudioElement = this.$refs.userAudio as HTMLAudioElement;
      if (userAudioElement) {
        this.audio_recorder?.stop();
        this.speech_recognition?.stop();
        this.audio_recorder = null;
        await wait_until(1000); // its important to wait for 1 second after clearing and audio recorder for process
        if (this.audio_media_stream) {
          this.set_audio_recorder(this.audio_media_stream); // Again intialized audio recorder
        }
        userAudioElement.src = "";
        this.individual_ans_blob = null;
        this.transcript = "";
        this.speech_mode = false;
        this.stopRecording();
      }
    },
    stopAllMediaStreams() {
      try {
        // --- Stop speech recognition ---
        if (this.speech_recognition) {
          try {
            this.speech_recognition.stop();
          } catch (e) {
            // ignore
          }
          this.speech_recognition = null;
        }

        // --- Stop and clear screen recorder + stream ---
        if (this.screen_recorder) {
          try {
            this.screen_recorder.stop();
          } catch (e) {
            // ignore
          }

          if (this.screen_recorder.stream) {
            try {
              this.screen_recorder.stream.getTracks().forEach((t) => t.stop());
            } catch (e) {
              // ignore
            }
          }

          this.screen_recorder.ondataavailable = null;
          this.screen_recorder.onstop = null;
          this.screen_recorder = null;
          this.media_stream = null;
          this.screen_recroding_end_time = new Date();
        }

        // --- Stop and clear camera recorder + stream ---
        if (this.camera_media_recorder) {
          try {
            this.camera_media_recorder.stop();
          } catch (e) {
            // ignore
          }

          if (this.camera_media_recorder.stream) {
            try {
              this.camera_media_recorder.stream
                .getTracks()
                .forEach((t) => t.stop());
            } catch (e) {
              // ignore
            }
          }

          this.camera_media_recorder.ondataavailable = null;
          this.camera_media_recorder.onstop = null;
          this.camera_media_recorder = null;
        }

        // --- Stop and clear camera media stream ---
        if (this.camera_media_stream) {
          try {
            this.camera_media_stream.getTracks().forEach((t) => t.stop());
          } catch (e) {
            // ignore
          }
          this.camera_media_stream = null;
          this.camera_recording_end_time = new Date();
        }

        // --- Stop and clear audio stream ---
        if (this.audio_media_stream) {
          try {
            this.audio_media_stream.getTracks().forEach((t) => t.stop());
          } catch (e) {
            // ignore
          }
          this.audio_media_stream = null;
        }

        // --- Extra: Stop and clear any <video> or <audio> elements still using live streams ---
        document.querySelectorAll("video, audio").forEach((el) => {
          const mediaEl = el as HTMLMediaElement;
          if (mediaEl.srcObject) {
            try {
              (mediaEl.srcObject as MediaStream)
                .getTracks()
                .forEach((t) => t.stop());
            } catch (e) {
              // ignore
            }
            mediaEl.srcObject = null;
          }
        });

        // --- Mark everything as stopped ---
        this.media_stopped = true;

        // Optional: small delay to ensure hardware is released (browser quirk)
        setTimeout(() => {
          console.log("✅ All media streams stopped and cleaned up");
        }, 300);
      } catch (e) {
        console.error("stopAllMediaStreams error:", e);
      }
    },
    async upload_recording_chunks(type: AssessmentRecordType) {
      const { mimeType, extension } = getRecordingMimeTypeAndExt();
      const assessment_id = this.app_eng_assessment.written[0].assessment_id; // Get assessment id
      const file_name = `assessment_${assessment_id}_user_${this.get_user.id}_${type}_recording.${extension}`;
      const blob_pick =
        type === AssessmentRecordType.SCREEN
          ? this.screen_recoding_chunks
          : this.camera_recorded_blobs;
      const fixedBlob = new Blob(blob_pick, { type: mimeType });
      // Clear blobs
      if (type === AssessmentRecordType.SCREEN) {
        this.screen_recoding_chunks = [];
      } else if (type === AssessmentRecordType.CAMERA) {
        this.camera_recorded_blobs = [];
      }
      const arrayBuffer = await fixedBlob.arrayBuffer();
      const bucket_prefix =
        this.get_company_details?.storage_path?.assessments_path
          ?.split("/")
          .slice(1)
          .join("/") ?? "open/assessments/inception";
      socketService.socket.emit("media-recorder-recording", {
        recording: arrayBuffer,
        user_id: this.get_user.id,
        file_name: file_name,
        completed: this.assessment_completed,
        cancelled: this.assessment_cancelled,
        assessment_id: assessment_id,
        assessment_type:
          this.get_company_details?.storage_path?.assessment_setting
            ?.candidates_english ?? "unknown",
        bucket_prefix,
        recording_type: type
      });
    },
    start_recording() {
      this.startTime = Date.now();
      this.recording = true;
      this.updateTime();
    },
    stopRecording() {
      if (this.recording) {
        this.recording = false;
        this.paused = false;
        this.totalPausedTime = 0;
        this.elapsedTime = "0:0";
      }
    },
    pauseRecording() {
      if (!this.paused) {
        this.paused = true;
        this.pauseStartTime = Date.now();
      }
    },
    resumeRecording() {
      if (this.paused) {
        this.totalPausedTime += Date.now() - this.pauseStartTime;
        this.paused = false;
        this.startTime += Date.now() - this.pauseStartTime;
        this.updateTime();
      }
    },
    updateTime() {
      if (this.recording && !this.paused) {
        const currentTime = Date.now();
        const elapsedTime = Math.floor((currentTime - this.startTime) / 1000);
        const minutes = Math.floor(elapsedTime / 60);
        const seconds = elapsedTime % 60;
        this.elapsedTime = minutes + ":" + seconds;
        if (this.recording) {
          setTimeout(this.updateTime, 1000); // Update time every second
        }
      }
    }
  },
  beforeDestroy() {
    // Clean up auto-save interval
    if (this.autoSaveInterval) {
      clearInterval(this.autoSaveInterval);
      this.autoSaveInterval = null;
    }

    // Clean up event listeners
    window.removeEventListener("online", this.handleOnline);
    window.removeEventListener("offline", this.handleOffline);
    if (this.connectionCheckIntervalId != null) {
      clearInterval(this.connectionCheckIntervalId);
      this.connectionCheckIntervalId = null;
    }
    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange
    );

    // Mark that we're navigating away so any late media events (like screen-share
    // "ended") don't try to re-request permissions while the user is leaving.
    this.isNavigatingAway = true;

    // Stop all media streams/recorders safely.
    try {
      this.stopAllMediaStreams();
    } catch (e) {
      // ignore
    }
    if (this.ttsAudio) this.ttsAudio.pause();
  }
});
